import React from 'react';

import getCoffee from "assets/img/get_coffee.gif";

export default class Empty extends React.Component {
    render() {
        return [
            <img {...this.props} key="img" height={258} width={258} src={getCoffee} style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', ...this.props.style }} />,
            <strong key="title" style={{ display: 'block' }}>{this.props.title}</strong>,
            <span key="subtitle" style={{ display: 'block' }}>{this.props.subtitle}</span>
        ];
    }
}